let t = "http://img.fengbolive.com/pic/avatar/{0}_{1}_200*200.jpg";
const state = {
    currentAnchorInfo: null,
    currentRoomId:0,
    currentRoomAddr:"",
    currentAnchorId:0,
    bFollow:false
}
const mutations = {
    ROOMINFO_CURRENT_ANCHOR_INFO(state, info){
        if(!info){
            state.currentAnchorInfo = info;
            return;
        }
        if (info.phid == 0) {
            info['img'] = "\\\\static/face/default.png";
        } else {
            info['img'] = t.format(info.id, info.phid);
        }

        info['name'] = decodeURI(info.name)
        let url = info.url;
        if (url.indexOf('hdlws.sinashow.com') > 0) {
            //var state = 0;
            //info['url'] = url.replace('hdlws.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
            info['url'] = url.replace('hdlws.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
        } else if (url.indexOf('hdlnew.sinashow.com') > 0) {
            //info['url'] = url.replace('hdlnew.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
            info['url'] = url.replace('hdlnew.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
        } else {
            //var state = 1;
            //info['url'] = url.replace('hdlks.sinashow.com', 'hlsks.sinashow.com').replace('.flv', '/index.m3u8');
            info['url'] = url.replace('hdlks.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
        }
        url = info.connectUrl;
        if (url) {
            if (url.indexOf('hdlws.sinashow.com') > 0) {
                //var state = 0;
                
                //info['url'] = url.replace('hdlws.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                info['micUrl'] = url.replace('hdlws.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
            } else if (url.indexOf('hdlnew.sinashow.com') > 0) {
                //info['url'] = url.replace('hdlnew.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                info['micUrl'] = url.replace('hdlnew.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
            } else {
                //var state = 1;
                //info['url'] = url.replace('hdlks.sinashow.com', 'hlsks.sinashow.com').replace('.flv', '/index.m3u8');
                info['micUrl'] = url.replace('hdlks.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
            }
        }

        url = info.security_url;
        if (url) {
            if (url.indexOf('hdlws.sinashow.com') > 0) {
                //var state = 0;
                //info['url'] = url.replace('hdlws.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                info['security_url'] = url.replace('hdlws.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
            } else if (url.indexOf('hdlnew.sinashow.com') > 0) {
                //info['url'] = url.replace('hdlnew.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                info['security_url'] = url.replace('hdlnew.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
            } else {
                //var state = 1;
                //info['url'] = url.replace('hdlks.sinashow.com', 'hlsks.sinashow.com').replace('.flv', '/index.m3u8');
                info['security_url'] = url.replace('hdlks.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
            }
        }
        state.currentAnchorInfo = info;
    },
    ROOMINFO_CURRENT_ANCHOR_ID(state, anchorId){
        state.currentAnchorId = anchorId;
    }
}

const actions = {
    roomInfo_Current_Anchor_Info({
        commit
    },  info){
        commit('ROOMINFO_CURRENT_ANCHOR_INFO', info)
    },
    roomInfo_Current_Anchor_Id({
        commit
    },  anchorId){
        commit('ROOMINFO_CURRENT_ANCHOR_ID', anchorId)
    }
}


const getters = {

}

export default {
    state,
    mutations,
    actions,
    getters
}